import axios from "axios";
import {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom";
import "./newteam.css"

  import {
   
    WhatsappShareButton,
   
  } from "react-share";

export default function Newteam()
{
    const navigate= useNavigate()
    var length=1;
    const [tekennames,setTakennames]= useState([])
    var tempname=[sessionStorage.getItem("gname").split(" ")[0]];
    
    var num=0;

    useEffect(async ()=>{
       const data= await axios.get(`https://spliteasy.onrender.com/auth/id/${sessionStorage.getItem("gid")}`)
    })
 
    
    var temp_name=[]

    const [teamname,setTeamname]= useState("")
    const post=(async (req,res)=>{
        res= await axios.post("https://spliteasy.onrender.com/new",req )
       
     })


const submit=()=>{
    if(teamname.length>0)
    {
    if(temp_name[length-1])
    tempname[length-1]=temp_name[length-1]
// console.log(tempname)
    let moarr=new Array(length)
    let mgarr=new Array(length)
    moarr.fill(0);
    mgarr.fill(0);
  
   let body=
    {
        "team": teamname,
       "names":tempname,
       "moneyowed": moarr,
       "moneygiven": mgarr,
       "google": sessionStorage.getItem("gid")
    };
    post(body)
    navigate("/all")
}
}

return(
    <div className="mid">
        
        <div className="temp2">
        <input type="text" className="grpname2" placeholder="Group Name..." onChange={(e)=>{setTeamname(e.target.value)}} name="" id="" />
        
        <div>
            <WhatsappShareButton
                {
                   ...{
                    title:`SplitEasy invite from ${sessionStorage.getItem("gname")}`,
                    url:` https://spliteasy.netlify.app/invite?team=${teamname}`
                   }
                }
               
                >
                 <button className="whatsapp" onClick={submit}>Share invite link</button>  
            </WhatsappShareButton>
            
        </div>
  
        </div>

     
    </div>
)

}